import { Create, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { ILibrary } from 'interfaces/libraries';
import { useNavigate } from 'react-router-dom';

export const LibrariesCreate = () => {
  const navigate = useNavigate();
  const { formProps, saveButtonProps } = useForm<ILibrary>({
    resource: 'prometheus/v2/libraries',
    redirect: false,
    successNotification: {
      message: 'Biblioteca criada com sucesso',
      description: 'A biblioteca foi criada com sucesso',
      type: 'success'
    },
    onMutationSuccess: () => navigate('/teaching_resources/libraries')
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Criar biblioteca">
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Nome"
          name="name"
          rules={[
            {
              required: true
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
